import React from 'react';
import './CTA.css';
import useScrollReveal from '../hooks/useScrollReveal';

const CALENDLY_URL = 'https://calendly.com/saelma';

export default function CTA() {
  const ref = useScrollReveal({ threshold: 0.2 });

  return (
    <section className="cta">
      <div className="cta-bg">
        <div className="cta-cinematic" />
        <div className="cta-glow" />
        <div className="cta-grid" />
      </div>
      <div className="cta-inner reveal" ref={ref}>
        <div className="cta-label">
          <span className="section-label">Ready to scale?</span>
        </div>
        <h2 className="cta-title">
          Let AI do the Work<br />
          so you can <span className="cta-accent">Scale Faster</span>
        </h2>
        <p className="cta-sub">Book a call today and start automating.</p>
        <div className="cta-actions">
          <a href={CALENDLY_URL} className="btn-primary cta-btn" target="_blank" rel="noreferrer">
            Book a free call
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
